import { Dialog, Box, Typography, DialogActions } from '@mui/material';
import { ReactElement, useState } from 'react';
import OtpInput from 'react-otp-input';
import { connect } from 'react-redux';
import { UserSettingService } from 'services/UserSettingService';
import {
    AppPrimaryButtonOutlined,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import { Utils } from 'shared/helpers';
import { ProfileActions } from 'state/profile/Action';
import { ProfileState } from 'state/profile/Reducer';

const TwoFactorEnableDisableDialog = (props: any): ReactElement => {
    const { showForm, onCloseForm, setProfileData } = props;
    const { profileState }: { profileState: ProfileState } = props;
    const [otp, setOtp] = useState('');
    const [loader, setLoader] = useState(false);

    // API Calls
    const toggleTwoFa = (formValues: any, callback: any): void => {
        setLoader(true);
        UserSettingService.toggleTwoFactor(formValues)
            .then((response: any) => {
                Utils.handleSuccessResponse(response);
                callback(true);
            })
            .catch((error: any) => {
                Utils.handleErrorResponse(error);
                callback();
            });
    };

    // UI Actions
    const actionToggleTwoFA = (): void => {
        const { enabled } = profileState.userInfo.twoFactorAuthentication;
        const formValues = {
            enabled: !enabled,
            code: otp,
        };
        toggleTwoFa(formValues, (status: any) => {
            onCloseForm();
            if (status) {
                profileState.userInfo.twoFactorAuthentication.enabled =
                    !enabled;
                setProfileData(JSON.parse(JSON.stringify(profileState)));
            }
        });
    };

    const pinOnChange = (value: any): void => setOtp(value);

    // UI Elements
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={showForm}
            className="twofactor-wrapper "
        >
            {' '}
            <Box className="pt-5 px-5">
                <Typography
                    variant="h3"
                    className="poppins-semi-bold text-primary"
                >
                    {profileState.userInfo.twoFactorAuthentication.enabled
                        ? 'Disable 2FA'
                        : 'Enable 2FA'}
                </Typography>

                <Typography
                    variant="body1"
                    className="lato-regular text-secondary my-2"
                >{`Are you sure wants to ${
                    profileState.userInfo.twoFactorAuthentication.enabled
                        ? 'disable'
                        : 'enable'
                } your 2FA.
              Enter the code from your authenticator app.`}</Typography>

                <Box className="justify-start mt-5">
                    <OtpInput
                        value={otp}
                        onChange={pinOnChange}
                        numInputs={6}
                        inputStyle="input-otp"
                        isInputNum
                        isInputSecure
                        shouldAutoFocus
                        separator={<span className="input-split" />}
                    />
                </Box>
            </Box>
            <DialogActions className="px-6">
                <AppPrimaryButtonOutlined
                    className="btn-small mb-4"
                    title="Cancel"
                    onClick={onCloseForm}
                />
                <AppPrimaryButton
                    className="btn-small mb-4"
                    title={
                        profileState.userInfo.twoFactorAuthentication.enabled
                            ? 'Disable 2FA'
                            : 'Enable 2FA'
                    }
                    onClick={actionToggleTwoFA}
                    disabled={otp.length !== 6 || loader}
                    isLoading={loader}
                    loadingSize={22}
                    loadingText="PROCESSING"
                />
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state: any): any => ({
    profileState: state.profileState,
});

const mapDispatchToProps = (dispatch: any): any => ({
    setProfileData: (profileData: any) =>
        dispatch(ProfileActions.setProfileData(profileData)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TwoFactorEnableDisableDialog);
